<template lang="">
  <div class="card-container">
    <ms-tooltip
      placement="bottom"
      effect="light"
      :hide-after="0"
    >
      <template #content>
        <span>{{ $t('Common.CardTooltip') }}</span>
      </template>
      <img
        class="card outline-none"
        :src="help.src"
        :width="help.width"
        :height="help.height"
        @click="openCard"
      >
    </ms-tooltip>

    <div
      v-if="courseQuantity > 0"
      class="course-quantity"
    >
      {{ 100 > courseQuantity ? courseQuantity : 99 }}
    </div>
  </div>
</template>

<script>
import MsTooltip from '@/components/tooltip'
import { useRoute } from 'vue-router'
// import { showHelp } from '@/common/common-fn'
import { emit, globalEvents } from '@/utils/event-bus'
import { mapState, mapActions } from 'vuex'
export default {
  components: {
    MsTooltip
  },

  data () {
    return {
      help: {
        src: require('@/assets/icons/svg/course-cart/ic_Cart.svg'),
        width: 24,
        height: 24
      }
    }
  },
  created () {
    const me = this
    me.getStudentCartList()
  },
  computed: {
    ...mapState('course', {
      studentCartList: 'studentCartList'
    }),
    // Số lượng học liệu trong giỏ
    courseQuantity () {
      return this.studentCartList.length
    }
  },
  methods: {
    ...mapActions('course', ['getStudentCartList']),
    // Mở giỏ học liệu
    openCard () {
      const me = this
      me.$router.push('/student/course-cart')
    }
  },

  setup () {
    const route = useRoute()

    const onShowHelp = () => {
      const helpID = route.meta.helpID

      helpID && emit(globalEvents.ShowHelp, helpID)
    }

    return {
      onShowHelp
    }
  }
}
</script>

<style lang="scss" scoped>
.card-container {
  height: 40px;
  padding: 0 8px;
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  .course-quantity {
    position: absolute;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: $color-semantic-pink;
    color: $color-primary;
    top: 0;
    right: 0;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    @include caption();
    @include font-bold();
  }
}
</style>
